<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :onConfigReady="onConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div class="simple-row">
            <div class="left">
                <div class='swb-btn swb-btn-small' v-if="checkActionPerm('create')" @click="goToNewPage();">新增请购单</div>
            </div>
            <div class="right">
                <div class="swb-btn swb-btn-small swb-btn-primary" @click="saveOrderList()">生成订单</div>
            </div>
        </div>
        <div name="tab-container" class="tab-container small base">
            <div class="tabs-nav">
                <ul class="head">
                    <li v-for="item in requireVoucherStateList" :class="{'current': item.name == checkStateValue}" class="head-item" @click="tabChange(item.name)">
                        <span>{{item.text}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>

</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    // 审核组件
    import { showComAuditorSelectDlg } from '../merchant/showSelectDlg'

    import { showComActionPostSelectDlg } from '../merchant/showSelectDlg'
    import { showBizAuditDlg } from '../merchant/showSelectDlg'
    import { deviceRequireVoucherUpdateDlg, requireGoodsItemStatisDlg } from './dialog'
    //检查用户操作权限
    import { checkUserActionPerm } from '../index'
    //
    import { getDefaultPageSizes } from '../../app.conf'

    //导入主件
    import SwbDeviceRequireVocherSave from './DeviceRequireVocherSave';

    Routes.add(SwbDeviceRequireVocherSave);

    import swbRequireGoodsItemList from './RequireGoodsItemList.vue'

    Vue.regist(swbRequireGoodsItemList);

    import swbDeviceRequireAuditRecList from './DeviceRequireAuditRecList.vue'

    Vue.regist(swbDeviceRequireAuditRecList);

    import swbRequireGoodsItemUpdate from './RequireGoodsItemUpdate.vue'

    Vue.regist(swbRequireGoodsItemUpdate);

    import SwbRequireAudit from './RequireAudit';

    Vue.regist(SwbRequireAudit);

    import SwbAppointAuditor from './AppointAuditor';

    Vue.regist(SwbAppointAuditor);

    import SwbDeviceRequireVocherSearch from './DeviceRequireVoucherSearch';
    Vue.regist(SwbDeviceRequireVocherSearch);

    import SwbDeviceRequireActRecList from './DeviceRequireActRecList';
    Vue.regist(SwbDeviceRequireActRecList);

    import SwbGoodsOrderList from '../order/GoodsOrderList';
    Vue.regist(SwbGoodsOrderList);

    import SwbContractGoodsOrderList from '../order/ContractGoodsOrderList';
    Vue.regist(SwbContractGoodsOrderList);

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    //导入Api
    import userApi from '../../api/user'
    import devcReqrApi from '../../api/devcReqr'
    import retailerApi from '../../api/retailer'
    import merchantComnApi from '../../api/merchtComn'

    //主件
    export default {
        name: 'swb-device-require-voucher-lowCost-list',
        path: '/device/require/voucher/lowCost/list',
        pathOld: '/adopted/device/voucher/list',
        avlActions: 'create|view|modify|delete|apply|assign_audit|audit|view_audit_rec|view_rec',
        avlActionNames: '新增、查看、修改、删除、申请、审核记录、审核、',
        avlScopes: 'retailer',
        desc: '设备请求单列表',
        helpArticleCode: 'swb-device-require-voucher-lowCost-list',
        data: function () {
            return {
                confKey: "swb-device-require-voucher-lowCost-list",
                queryOnLoad: true,
                //
                theTableHeight: 300,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 300,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,

                requireVoucherState: {},
                requireVoucherStateList: [],
                requireVoucherList: [],
                comId: null,
                postId: null,
                pickerOptions0: null,
                pickerOptions1: null,
                beginTime: null,
                endTime: null,
                requireComName: null,
                applicantName: null,
                checkStateValue: "All",
                deviceRequireVoucher: {
                    itemList: [],
                },
                userInfo: null,
                retailerId: null,
                searchShow: false,
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                //
                no: null,
                headComFlag: false,
                shopFlag: false,
                goodsPurch: null
            }
        },
        created: function () {
            let routeQuery = this.$getRouteQuery();
            this.no = routeQuery.no || null;
            this.checkStateValue = routeQuery.checkStateValue || "All";
            this.goodsPurch = getEnumInfoWith('purchType', 'name', 'Goods').value;
            this.getCurrentUserInfo();
            this.checkAuditByHeadCom();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;

            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('.simple-row,[name="query-sort-block"], [name="tab-container"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            checkAuditByHeadCom: function () {
                let self = this;
                let postData = {
                    code: "asset.purch.audit.by.head.com"
                };
                merchantComnApi.getMerchantBizParamValue(postData, function (result) {
                    if(result.type == "info") {
                        self.headComFlag = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },

            onConfigReady() {
                let no = this.no;
                if(no != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {value: no};
                    let fieldInfo = {};
                    fieldInfo["no"] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'no': function (row, colName, colValue, rowIndex, btnName) {
                        return '<a href="#" class="table-cell-link">' + row.no + '</a>';
                    },
                    'centBuyMode': function (row, colName, colValue, rowIndex, btnName) {
                        let domHtml = "";
                        if(row.centBuyMode) {
                            domHtml = domHtml + '<span>集采</span>'
                        } else {
                            domHtml = domHtml + '<span>自采</span>'
                        }
                        return domHtml;
                    },
                    "purchType": function (row, colName, colValue, rowIndex, btnName) {
                        return self.getPurchType(row.purchType);
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let domHtml = '';
                        let btnList = [];
                        if(self.checkActionPerm('view')) {
                            btnList.push({
                                name: 'view',
                                text: '查看'
                            });
                        }
                        // && row.requireComId == self.comId 谁创建谁申请
                        if((row.applyState == 0 || row.auditState == -1) &&  self.checkActionPerm('apply', row.creatorPostId)) {
                            btnList.push({
                                name: 'apply',
                                text: '申请'
                            });
                        }
                        // 谁创建谁修改
                        if((row.applyState == 0 || row.auditState == -1) && self.checkActionPerm('modify', row.creatorPostId)) {
                            btnList.push({
                                name: 'modify',
                                text: '修改'
                            });
                        }
                        // 谁创建谁删除
                        if((row.applyState == 0 || row.auditState == -1) && self.checkActionPerm('delete', row.creatorPostId)) {
                            btnList.push({
                                name: 'delete',
                                text: '删除'
                            });
                        }
                        if(row.applyState == 1 && row.auditState == 0 && (row.auditorPostId == null || self.postId == row.auditorPostId) && self.checkActionPerm('audit')) {
                            btnList.push({
                                name: 'audit',
                                text: '审核'
                            });
                        }
                        if(self.checkActionPerm('view_audit_rec')) {
                            btnList.push({
                                name: 'view_audit_rec',
                                text: '审核记录'
                            });
                        }
                        if(self.checkActionPerm('view_rec')) {
                            btnList.push({
                                name: 'view_rec',
                                text: '操作记录'
                            });
                        }
                        if(self.checkActionPerm('saveOrder') && !row.goodsOrderGenFlag && row.auditState == 1) {
                            btnList.push({
                                name: 'saveOrder',
                                text: '生成订单'
                            });
                        }
                        if(self.checkActionPerm('showGoodsOrder') && row.goodsOrderGenFlag) {
                            btnList.push({
                                name: 'showGoodsOrder',
                                text: '查看订单'
                            });
                        }
                        if(self.checkActionPerm('contractShowGoodsOrder') && row.goodsOrderGenFlag) {
                            btnList.push({
                                name: 'contractShowGoodsOrder',
                                text: '查看合同订单'
                            });
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    'no': function (row, colName, colValue, rowIndex, btnName) {
                        self.showDialog(row);
                    },
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName == 'view') {
                            self.showDialog(row);
                        } else if(btnName == 'apply') {
                            self.saveDeviceRequireVocher(row.id, row.creatorPostId);
                        } else if(btnName == 'modify') {
                            self.goToNewPage(row.id);
                        } else if(btnName == 'delete') {
                            self.deleteRow(row);
                        } else if(btnName == 'audit') {
                            self.showAuditDialog(row, row.auditorPostId);
                        } else if(btnName == 'view_audit_rec') {
                            self.showAuditRecDialog(row);
                        } else if(btnName == 'view_rec') {
                            self.showActRecDialog(row.id);
                        } else if(btnName == 'saveOrder') {
                            self.saveOrderById(row.id);
                        } else if(btnName == 'showGoodsOrder') {
                            self.showOrderById(row.id);
                        } else if(btnName == 'contractShowGoodsOrder') {
                            self.contractShowGoodsOrder(row.id);
                        }
                    }
                });
            },
            getPurchType: function (ourchType) {
                return getEnumInfoWith("purchType", "value", ourchType).text;
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;

                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            queryHandler: function (data) {
                this.queryModel = data;
                this.pageNumber = 1;
                this.getRequireVoucherList(this.checkStateValue);
            },
            //检查资源具体操作权限
            checkActionPerm: function (action) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action);
            },

            showSearch: function (flag) {
                this.searchShow = flag;
            },
            // 页签切换
            tabChange: function (val) {
                this.pageNumber = 1;
                this.getRequireVoucherList(val);
            },
            // 起始时间变化事件
            beginTimeChange: function (val) {
                if(!Utils.isNoB(this.endTime)) {
                    let endTime = this.endTime.format("yyyy-MM-dd");
                    if(endTime < val) {
                        MsgBox.warning("起始时间不能大于结束时间");
                        this.beginTime = null;
                    }
                }
            },
            // 结束时间变化事件
            endTimeChange: function (val) {
                if(!Utils.isNoB(this.beginTime)) {
                    let beginTime = this.beginTime.format("yyyy-MM-dd");
                    if(beginTime > val) {
                        MsgBox.warning("结束时间不能小于起始时间");
                        this.endTime = null;
                    }
                }
            },
            getCurrentUserInfo: function () {
                let self = this;
                let data = {};
                userApi.getUserInfoByContext(data, function (result) {
                    if(result.type === "info") {
                        let userInfo = result.data;
                        let requireVoucherStateList = getEnumList('requireVoucherState');
                        let Reported = getEnumInfoWith('requireVoucherState', 'name', 'Reported').value;
                        let Applied = getEnumInfoWith('requireVoucherState', 'name', 'Applied').value;

                        let scopeEntity = userInfo.scopeEntity;
                        for(let i = requireVoucherStateList.length - 1; i > 0; i--) {
                            let requireVoucherState = requireVoucherStateList[i];
                            if(scopeEntity.comLevel == 1) {
                                if(requireVoucherState.value == Reported) {
                                    requireVoucherStateList.splice(i, 1);
                                }
                            }
                            if(scopeEntity.shopFlag) {
                                if(requireVoucherState.value == Applied) {
                                    requireVoucherStateList.splice(i, 1);
                                }
                            }
                        }
                        requireVoucherStateList.push({
                            "value": 5,
                            "text": "待生成订单",
                            "name": "waitOrder"
                        }, {
                            "value": 6,
                            "text": "已生成订单",
                            "name": "orderEnd"
                        })

                        self.postId = scopeEntity.postId;
                        self.comId = scopeEntity.getComId(scopeEntity.comLevel);
                        self.requireVoucherStateList = requireVoucherStateList;
                        self.userInfo = userInfo;
                        self.shopFlag = scopeEntity.shopFlag
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getRequireVoucherList(this.checkStateValue);
            },

            getRequireVoucherList: function (value) {
                let self = this;
                if(Utils.isNoB(value)) {
                    self.checkStateValue = "All";
                } else {
                    self.checkStateValue = value;
                }
                let dateForm = self.beginTime;
                let dateTo = self.endTime;
                if(null != dateForm && null != dateTo && dateForm > dateTo) {
                    MsgBox.warning("结束时间不能大于开始时间");
                    return false;
                }
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.voucerState = value;
                if(!Utils.isNoB(self.no)) {
                    filterItems.no = self.no;
                }
                filterItems.stuffFlag = true;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                let theLoad = MsgBox.loading();
                devcReqrApi.getDeviceRequireVoucherList(postData, function (result) {
                    theLoad.close();
                    if(result.type === "info") {
                        let resultData = result.data;
                        //
                        let pagination = result.data.pagination;
                        self.renderTable(resultData.rows, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            deleteRow: function (rowdata) {
                let self = this;
                self.$confirm('是否删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoad = MsgBox.loading();
                    let postData = {};
                    postData.id = rowdata.id;
                    devcReqrApi.deleteDeviceRequireVoucher(postData, function (result) {
                        if(result.type === 'info') {
                            self.getRequireVoucherList(self.row);
                            MsgBox.success("删除成功")
                        } else {
                            MsgBox.warning(result.message);
                        }
                        theLoad.hide();
                    })
                });
            },
            showDialog: function (data) {
                let theDlg = Vue.$showDialog({
                    title: "请购单详情",
                    width: '80%',
                    height: '80%',
                    centerButtons: false,
                    showCloseBtn: true,
                    cancelText: '关闭',
                    okVisible: false,
                    template: '<div><swb-require-goods-item-list :item="id" ref="swb_require_itemList"></swb-require-goods-item-list>' +
                    '</div>',
                    data: {
                        id: data.id
                    },
                });
            },
            showAuditRecDialog: function (data) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: "审核记录",
                    width: 945,
                    height: 600,
                    showCloseBtn: true,
                    okVisible: false,
                    cancelText: "关闭",
                    template: '<div><swb-device-require-audit-rec-list :tableHeight="500" :item="id" ref="swb_device_require_audit_rec_list"></swb-device-require-audit-rec-list>' +
                    '</div>',
                    data: {
                        loading: false,
                        id: data.id
                    },
                });
            },

            showActRecDialog: function (id) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: "审核记录",
                    width: '90%',
                    height: '80%',
                    showCloseBtn: true,
                    okVisible: false,
                    cancelText: "关闭",
                    template: '<div><swb-device-require-act-rec-list :voucherId="id" ></swb-device-require-act-rec-list>' +
                    '</div>',
                    data: {
                        id: id
                    },
                });
            },

            showAuditDialog: function (data) {
                let self = this;
                let showFinalAudit = true;
                if(Utils.isTrue(self.shopFlag)) {
                    if(data.centBuyMode) {
                        showFinalAudit = false;
                    } else if(self.headComFlag) {
                        showFinalAudit = false;
                    }
                }
                showBizAuditDlg({
                    title: "请购单 - 审核",
                    showFinalAudit: showFinalAudit,
                    selectNextPost: true,
                    nextPostParams: {
                        rescUrl: Vue.$getClassInfo(this).path,
                        action: 'audit',
                        useParents: true
                    }
                }, function (resultData) {
                    resultData = resultData || {};
                    let nextPostResultData = resultData.nextPostResultData || null;
                    let auditorPostId = null;
                    let appliedComId = null;
                    let appliedComLevel = null;
                    if(nextPostResultData != null) {
                        auditorPostId = nextPostResultData.postId;
                        appliedComId = nextPostResultData.comId;
                        appliedComLevel = nextPostResultData.comLevel
                    }
                    let finalAudit = resultData.finalAudit;
                    let postDate = {
                        id: data.id,
                        auditState: resultData.auditState,
                        auditDesc: resultData.auditDesc,
                        finalAudit: finalAudit,
                        auditorPostId: auditorPostId,
                        appliedComLevel: appliedComLevel,
                        appliedComId: appliedComId,
                        retailerId: data.retailerId,
                    };
                    // 终审可以重新修改商品信息
                    if(Utils.isTrue(finalAudit) && data.purchType == self.goodsPurch) {
                        deviceRequireVoucherUpdateDlg({id: data.id, auditDesc: resultData.auditDesc}, function (result, theDlg) {
                            postDate.goodsItemList = result;
                            self.deviceRequireVoucherAudit(postDate, theDlg,finalAudit,resultData.auditState);
                        })
                    } else {
                        self.deviceRequireVoucherAudit(postDate, null,finalAudit,resultData.auditState);
                    }
                }, this);
            },

            deviceRequireVoucherAudit: function (postDate, theDlg,finalAudit,auditState) {
                let self = this;
                let theLoad = MsgBox.loading();
                devcReqrApi.auditDeviceRequireVoucher(postDate, function (result) {
                    theLoad.hide();
                    if(result.type === 'info') {
                        if(!Utils.isNoB(theDlg)) {
                            theDlg.close();
                        }
                        let checkStateValue = "All";
                        if(Utils.isTrue(finalAudit)){
                            checkStateValue = "AuditPass";
                        }else{
                            if(auditState == 1){
                                checkStateValue = "Reported";
                            }else{
                                checkStateValue = "AuditFail";
                            }
                        }
                        self.checkStateValue = checkStateValue;
                        MsgBox.success("审核成功");
                        self.getRequireVoucherList(checkStateValue);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            saveDeviceRequireVocher: function (id, initPostId) {
                let self = this;
                let headComFlag = self.headComFlag;
                showComActionPostSelectDlg({
                    rescUrl: Vue.$getClassInfo(this).path,
                    action: 'audit',
                    useParent: true,
                    headComFlag: headComFlag,
                    initPostId: initPostId
                }, function (resultData) {
                    resultData = resultData || {};
                    if(resultData.postId == null) {
                        Toast.show('请选 择审核岗位', 3000, 'warning');
                        return false;
                    }
                    //
                    let postData = {
                        id: id,
                        auditorPostId: resultData.postId,
                        requireComLevel: resultData.comLevel,
                        appliedComLevel: resultData.comLevel,
                        applyDesc: resultData.applyDesc
                    };
                    //
                    let theLoad = MsgBox.loading();
                    devcReqrApi.applyDeviceRequireVoucher(postData, function (result) {
                        if(result.type == 'info') {
                            self.checkStateValue = "Applied";
                            self.getRequireVoucherList("Applied");
                        } else {
                            MsgBox.failure(result.message);
                        }
                        theLoad.hide();
                    });

                }, this);
            },
            goToNewPage: function (id) {
                let self = this;
                let parentPath = "/device/require/voucher/lowCost/list";
                this.$router.push({
                    path: SwbDeviceRequireVocherSave.path,
                    query: {
                        id: id,
                        lowCostFlag: true,
                        parentPath: parentPath,
                    }
                });
            },
            saveOrderById: function (id) {
                let self = this;
                self.$confirm('确定生成订单?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {
                        id: id
                    };
                    let theLoad = MsgBox.loading();
                    devcReqrApi.saveOrderById(postData, function (result) {
                        if(result.type == 'info') {
                            MsgBox.success("已生成订单");
                            self.checkStateValue = "orderEnd";
                            self.getRequireVoucherList("orderEnd");
                        } else {
                            MsgBox.failure(result.message);
                        }
                        theLoad.hide();
                    });
                });
            },
            showOrderById: function (id) {
                this.$router.push({
                    path: SwbGoodsOrderList.path,
                    query: {
                        cgVoucherId: id,
                    }
                });
            },
            contractShowGoodsOrder: function (id) {
                this.$router.push({
                    path: SwbContractGoodsOrderList.path,
                    query: {
                        cgVoucherId: id,
                    }
                });
            },
            saveOrderList: function () {
                let self = this;
                let selectList = this.getTableSelection() || [];
                for(let i = 0; i < selectList.length; i++) {
                    let select = selectList[i];
                    if(select.auditState != 1) {
                        let title = select.auditState == 0 ? "未审核" : "未审核通过";
                        MsgBox.warning("【" + select.no + "】" + title + "，不可生成订单");
                        return;
                    }
                    if(Utils.isTrue(select.goodsOrderGenFlag)) {
                        MsgBox.warning(select.no + "已生成订单");
                        return;
                    }
                }
                let voucherIds = selectList.pluck("id") || [];
                requireGoodsItemStatisDlg({voucherIds: voucherIds, lowCostFlag: true}, function (resultDLg, theDlg) {
                    theDlg.close();
                    let theLoad = MsgBox.loading();
                    devcReqrApi.saveRequireGoodsItemList(resultDLg, function (result) {
                        theLoad.hide();
                        if(result.type == "info") {
                            let postData = {
                                ids: voucherIds
                            };
                            devcReqrApi.saveOrderBatch(postData, function (orderResult) {
                                if(orderResult.type == 'info') {
                                    MsgBox.success("已生成订单");
                                    self.checkStateValue = "orderEnd";
                                    self.getRequireVoucherList("orderEnd");
                                } else {
                                    MsgBox.failure(orderResult.message);
                                }

                            });
                        } else {
                            MsgBox.failure(orderResult.message);
                        }
                    })

                });
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/retailer/DeviceRequireVoucherLowCostList.vue